/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { NumberAndAlphabetComparator } from '../../../../SharedModules/utilities/utilities';

function batchNumberComparator(valueA, valueB) {
  return valueA?.toLowerCase().localeCompare(valueB?.toLowerCase());
}

function CCNComparator(valueA, valueB) {
  return valueA?.toLowerCase().localeCompare(valueB?.toLowerCase());
}

export const hideColumns = ['action'];
export const TableHeadForChecks = [
  {
    headerName: 'Action',
    field: hideColumns[0],
    cellRenderer: 'ActionCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    cellClass: 'frr-overflow-visible',
    editable: false,
    sortable: false,
  },
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    comparator: batchNumberComparator,
    sort: 'asc',
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CCN',
    field: 'checkIdentifier',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    comparator: CCNComparator,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    editable: false,
    sortable: true,
    cellRenderer: 'DateRenderer',
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    dataAlignRight: true,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    columnSpan: 3,
    minWidth: Styles.Width_250,
    comparator: NumberAndAlphabetComparator,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Information',
    field: 'checkInfo',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    columnSpan: 4,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    cellRenderer: 'DateRenderer',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmark Date',
    field: 'postmarkedDt',
    editable: false,
    sortable: true,
    cellRenderer: 'DateRenderer',
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    editable: false,
    sortable: true,
    cellRenderer: 'DateRenderer',
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amount',
    field: 'checkAmt',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Allocated Amount',
    field: 'totAllocatedAmt',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    dataAlignRight: true,
  },
  {
    headerName: 'Format',
    field: 'paymentMediaTypeCd',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Resolution',
    field: 'disputeResolutionCd',
    cellRenderer: 'CheckCellRender',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_200,
    resizable: false,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
